export var ON_SDK_READY = "__ON_SDK_READY";
export var REFRESH_SDK = "__REFRESH_SDK";
export var BRIDGE = "__BRIDGE";
